import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { checkPaymentStatusThunk, reloadServices } from '../../../../ServicePickerWidget';
import { sleep } from '../../../../common/utils/sleep';
import { selectConfigValue } from '../../../../ServicePickerWidget/selectors/config';
import { setPaymentProcessingData } from '../../../../ServicePickerWidget/actions/paymentProcessing';
import { changePlacingType } from '../../../../ServicePickerWidget/actions/publishTerms';
import { EPaymentType } from '../../../../ServicePickerWidget/types/reducers/paymentProcessing';

export const usePayPackageMicrofrontendEvents = () => {
  const loadPublishTermsTimeout = useSelector(selectConfigValue('loadPublishTermsAfterBuyPackageTimeout'));

  const dispatch = useDispatch();

  const paymentSuccessHandler = async (e: CustomEvent) => {
    // КОСТЫЛЬ: Сбрасываем тип размещения, чтобы проставлялся чекбокс «Из пакета» после запроса check-service
    dispatch(changePlacingType(null));

    if (e.detail.paymentId) {
      const { paymentId, provider } = e.detail;

      const type = EPaymentType.Package;

      dispatch(setPaymentProcessingData({ paymentId, provider, type }));

      dispatch(checkPaymentStatusThunk({ type, paymentId, provider }));
    } else {
      // КОСТЫЛЬ: Даём время на покупку пакета на бэке
      await sleep(loadPublishTermsTimeout);

      dispatch(reloadServices());
    }
  };

  React.useEffect(() => {
    window.addEventListener('payment-success', paymentSuccessHandler);

    return () => {
      window.removeEventListener('payment-success', paymentSuccessHandler);
    };
  });
};
